import _get from 'lodash/get';
import {
  trackPageView,
  event,
  cat,
  custom,
} from 'common/utils/instrumentation';
import { getCompanyID } from 'helper/user';
import { MODE } from './constants';

const trackHomePageView = (mode, userInfo, order) => {
  const companyID = getCompanyID(userInfo);
  let eventName;
  let categoryName;
  let bookingMode;
  // eslint-disable-next-line default-case
  switch (mode) {
    case MODE.HOME: {
      eventName = event.HOMEPAGE_PV;
      categoryName = cat.GE_HOMEPAGE;
      bookingMode = 'SINGLE';
      break;
    }
    case MODE.SINGLE_BOOK: {
      eventName = event.DELIVERY_DETAILS_PV;
      categoryName = cat.GE_DELIVERY_DETAILS;
      bookingMode = 'SINGLE';
      break;
    }
    case MODE.MULTI_BOOK: {
      eventName = event.DELIVERY_DETAILS_PV;
      categoryName = cat.GE_DELIVERY_DETAILS;
      bookingMode = 'MULTIPLE';
      break;
    }
  }
  if (eventName && categoryName && bookingMode) {
    trackPageView(eventName, categoryName, {
      [custom.COMPANY_ID]: companyID,
      PICKUP_POI: _get(order, 'senderLocation.id'),
      DROPOFF_POI: _get(order, 'recipientLocations', []).map(r => r.id),
      SERVICE_TYPE: _get(order, 'SERVICE_TYPE.value'),
      FARE: _get(order, 'quote.forRender.amount'),
      CITY_ID: _get(userInfo, 'selectedCity.cityID'),
      BOOKING_MODE: bookingMode,
    });
    return;
  }

  if (mode === MODE.BULK_UPLOAD) {
    trackPageView(event.BULK_UPLOAD_REVIEW_PV, cat.GE_BULK_UPLOAD_REVIEW, {
      [custom.COMPANY_ID]: companyID,
    });
  }
};

export default trackHomePageView;
